import { env } from '@/env'

export const isProduction = env.VITE_ENV === 'production'

export const suffixBaseURL = {
  booking: '/api/booking/v1',
  agency: '/my-business/api/agency/v1/',
  batchReservations: '/my-batches/api/batch/v1',
} as const

const apiConfig = {
  baseUrl: env.VITE_ENABLE_MSW ? '/' : env.VITE_API_URL,
}

export { apiConfig }
